import { render, staticRenderFns } from "./addAsset.vue?vue&type=template&id=6e6b2546&"
import script from "./addAsset.vue?vue&type=script&lang=js&"
export * from "./addAsset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports